import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetUnopenedNotificationGroupsCountQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetUnopenedNotificationGroupsCountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, notificationGroups: { __typename?: 'NotificationGroupConnection', timestamp?: string | null, totalCount: number, nodes: Array<{ __typename?: 'NotificationGroupAccessRequestApproved', id: string } | { __typename?: 'NotificationGroupAccessRequestDenied', id: string } | { __typename?: 'NotificationGroupAccessRequestSubmitted', id: string } | { __typename?: 'NotificationGroupAssetAssignedToYou', id: string } | { __typename?: 'NotificationGroupAssetStatusChanged', id: string } | { __typename?: 'NotificationGroupCommentCreated', id: string } | { __typename?: 'NotificationGroupCommentCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupFileUploaded', id: string } | { __typename?: 'NotificationGroupReplyCreated', id: string } | { __typename?: 'NotificationGroupReplyCreatedShareAccess', id: string } | { __typename?: 'NotificationGroupRequesterAccessRequestApproved' } | { __typename?: 'NotificationGroupRequesterAccessRequestDenied' } | { __typename?: 'NotificationGroupTranscriptCompletedSelf' } | { __typename?: 'NotificationGroupTransferBatchCompleted', id: string } | { __typename?: 'NotificationGroupTransferBatchCompletedSelf', id: string } | { __typename?: 'NotificationGroupUserMentioned', id: string } | { __typename?: 'NotificationGroupUserMentionedShareAccess', id: string }> } } | null };


export const GetUnopenedNotificationGroupsCount = /*#__PURE__*/ gql`
    query GetUnopenedNotificationGroupsCount($accountId: ID!) {
  account(accountId: $accountId) {
    id
    notificationGroups(page: {first: 100}, filters: {unopenedOnly: true}) {
      nodes {
        ... on NotificationGroupCommentCreated {
          id
        }
        ... on NotificationGroupFileUploaded {
          id
        }
        ... on NotificationGroupReplyCreated {
          id
        }
        ... on NotificationGroupTransferBatchCompleted {
          id
        }
        ... on NotificationGroupTransferBatchCompletedSelf {
          id
        }
        ... on NotificationGroupUserMentioned {
          id
        }
        ... on NotificationGroupAssetAssignedToYou {
          id
        }
        ... on NotificationGroupAssetStatusChanged {
          id
        }
        ... on NotificationGroupAccessRequestSubmitted {
          id
        }
        ... on NotificationGroupAccessRequestDenied {
          id
        }
        ... on NotificationGroupAccessRequestApproved {
          id
        }
        ... on NotificationGroupCommentCreatedShareAccess {
          id
        }
        ... on NotificationGroupReplyCreatedShareAccess {
          id
        }
        ... on NotificationGroupUserMentionedShareAccess {
          id
        }
      }
      timestamp @client
      totalCount
    }
  }
}
    ` as unknown as DocumentNode<GetUnopenedNotificationGroupsCountQuery, GetUnopenedNotificationGroupsCountQueryVariables>;

          

          export const useGetUnopenedNotificationGroupsCountQuery = (options?:QueryHookOptions<GetUnopenedNotificationGroupsCountQuery, GetUnopenedNotificationGroupsCountQueryVariables>) => useQuery(GetUnopenedNotificationGroupsCount, options);

          

          export type GetUnopenedNotificationGroupsCountQueryOptions = QueryHookOptions<GetUnopenedNotificationGroupsCountQuery, GetUnopenedNotificationGroupsCountQueryVariables>;

          

          export const useGetUnopenedNotificationGroupsCountLazyQuery = (options?:LazyQueryHookOptions<GetUnopenedNotificationGroupsCountQuery, GetUnopenedNotificationGroupsCountQueryVariables>) => useLazyQuery(GetUnopenedNotificationGroupsCount, options);

          

          export type GetUnopenedNotificationGroupsCountQueryResult = ReturnType<typeof useGetUnopenedNotificationGroupsCountQuery>;

          
